"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseArticle = parseArticle;
exports["default"] = void 0;

var _urlify = _interopRequireDefault(require("urlify"));

var BetaDates = _interopRequireWildcard(require("ion-betaDates"));

var _ionSections = _interopRequireDefault(require("ion-sections"));

var _parseArticle2 = require("./parse-article");

var _ionUtil = require("ion-util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var logger = console;

var urlify = _urlify["default"].create({
  addEToUmlauts: true,
  szToSs: true,
  spaces: '-',
  nonPrintable: '',
  toLower: true,
  trim: false
}); // // These items below should be pulled from siteProps  *****************************************************


var defaultArticleSectionUri = 'news'; // // *****************************************************

var SLUG_REGEX = '([a-z0-9_.-]+)';
var COMPETITION_REGEX = '\\[competition\\s?\\=\\s?[\'"]?%s[\'"]?\\]';
var TIMELINE_REGEX = /\[timeline=([^ ]+)(?: mode=([^ ]+))?\]/g;

function isSimilarText(text, other) {
  if (text && other) {
    text = text.replace(/\W/g, '').toLowerCase();
    other = other.replace(/\W/g, '').toLowerCase();
    return text === other;
  }

  return false;
}

var Article = /*#__PURE__*/function () {
  function Article(props) {
    _classCallCheck(this, Article);

    Object.assign(this, props); // if (typeof this.contentKey === 'string') {
    //   this.contentKey = parseInt(this.contentKey)
    // }

    if (this.modified > 0) {
      this.modified = new Date(this.modified).toISOString().substring(0, 16);
    }

    if (this.published > 0) {
      this.published = new Date(this.published).toISOString().substring(0, 16);
    }

    if (!this.bodyHTML) {
      this.bodyHTML = '';
    } else if (!/[A-Z][a-z]/.test(this.bodyHTML)) {
      this.bodyHTML = '';
    }

    if (this["abstract"]) {
      this.formatAbstract();
    }

    if (!this.relatedArticles) {
      this.relatedArticles = [];
    }
  } // This stuff below was brought in from BaobabArticle  *****************************************************


  _createClass(Article, [{
    key: "extractRegex",
    value: function extractRegex(regex, string) {
      var match = string.match(regex);

      if (match && match.length > 1) {
        return match[1];
      }
    }
  }, {
    key: "formatAbstract",
    value: function formatAbstract() {
      this["abstract"] = this["abstract"].replace(/^\* /, '');

      if (this.author) {
        if (isSimilarText(this["abstract"], this.author)) {
          this["abstract"] = '';
        } else {// logger.debug('author', this.author, this.abstract)
        }
      } else {// logger.debug('author none', ObjectLogs.keys(this))
      }

      var regex = /^(Address:\s*)?(.*\w)\W+(Phone|Tel|phone|tel)\s*:\s*([0-9][0-9\s]+[0-9])\W*$/;
      var match = this["abstract"].match(regex);

      if (match) {
        this.address = match[2];
        this.phone = match[4];

        if (!this.bodyHTML) {
          var phoneNumber = this.extractRegex(/\+?0?([1-9]{8})/, this.phone.replace(/[^0-9+-]/g, '')); // logger.debug('listing', match, this.bodyHTML, phoneNumber)

          if (phoneNumber && phoneNumber.length === 8) {
            this.bodyHTML = "<p class=\"link\"><svg class=\"iconSvgPhone\" viewBox=\"0 0 1792 1792\"><path d=\"M496.4,653c-54.3-44.4-116.9-104.1-171.2-171.5c-38.1-47.2-71.8-96.8-37-131.7l-244.1-244C8.5,150.3-70.4,362.1,267.6,708.7C623.8,1074,853.4,995.9,893,954.8L654.9,716.5C621.6,749.7,578.7,720.1,496.4,653z M978.8,816.3v-0.3c0,0-185.6-185.5-185.7-185.6c-14.7-14.9-38.3-14.4-52.9,0.1l-67.4,67.3l238.5,238.9c0,0,67.5-67.4,67.4-67.4l0.1-0.1C994.5,854,992.9,830.4,978.8,816.3z M374,264.2V264c15.6-15.6,14-39,0-53.1v-0.2c0,0-191.1-191-191.2-191.1C168.1,4.9,144.6,5.2,130,19.7L62.6,87.3l243.9,244.1C306.6,331.5,374,264.3,374,264.2z\"></path></svg><a href=\"tel:+27-".concat(phoneNumber, "\">").concat(this.phone, "</a>");
          } else {
            this.bodyHTML = "<p class=\"link\"><svg class=\"iconSvgPhone\" viewBox=\"0 0 1792 1792\"><path d=\"M496.4,653c-54.3-44.4-116.9-104.1-171.2-171.5c-38.1-47.2-71.8-96.8-37-131.7l-244.1-244C8.5,150.3-70.4,362.1,267.6,708.7C623.8,1074,853.4,995.9,893,954.8L654.9,716.5C621.6,749.7,578.7,720.1,496.4,653z M978.8,816.3v-0.3c0,0-185.6-185.5-185.7-185.6c-14.7-14.9-38.3-14.4-52.9,0.1l-67.4,67.3l238.5,238.9c0,0,67.5-67.4,67.4-67.4l0.1-0.1C994.5,854,992.9,830.4,978.8,816.3z M374,264.2V264c15.6-15.6,14-39,0-53.1v-0.2c0,0-191.1-191-191.2-191.1C168.1,4.9,144.6,5.2,130,19.7L62.6,87.3l243.9,244.1C306.6,331.5,374,264.3,374,264.2z\"></path></svg>".concat(this.phone);
          }

          this.bodyHTML += "<p class=\"link\"><svg class=\"iconSvgEmail\" viewBox=\"0 0 1792 1792\"><path d=\"M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z\"/></svg>".concat(this.address, "<p>");
        }

        this["abstract"] = 'Tel: ' + this.phone; // + '\n' + this.address;
      } else {
        this["abstract"] = this["abstract"].replace(/^<p>/, '');
        this["abstract"] = this["abstract"].replace(/<\/p>$/, '');
        this["abstract"] = this["abstract"].replace(/<!--PSTYLE=Normal-->/, '');
        this["abstract"] = this["abstract"].replace(/<p>/, '');
      }

      if (!this.bodyHTML) {
        this.bodyHTML = this["abstract"];
      }
    }
  }, {
    key: "getCanonicalUri",
    value: function getCanonicalUri() {
      if (this.externalUri) {
        return this.externalUri;
      }

      var name = this.buildName();
      name += '-' + this.contentKey;
      var sectionId = this.category || this.section;

      if (sectionId) {
        return sectionId + '/' + name;
      } else {
        logger.warn('getCanonicalUri: No section defined for article:', this.contentKey);
        return name;
      }
    }
  }, {
    key: "basename",
    value: function basename(path) {
      var matcher = path.match(/([^\/]+)\.[a-z]+$/);

      if (matcher) {
        return matcher[1];
      } else {
        return path;
      }
    }
  }, {
    key: "getImageObject",
    value: function getImageObject() {
      if (this.image) {
        return this.image;
      } else if (!(0, _ionUtil.isEmpty)(this.images)) {
        return this.images[0];
      } else {
        return null;
      }
    }
  }, {
    key: "getBodyLead",
    value: function getBodyLead() {
      if (this.bodyLead) {
        return this.bodyLead;
      }

      return '';
    }
  }, {
    key: "getBodyMore",
    value: function getBodyMore() {
      if (this.bodyMore) {
        return this.bodyMore;
      }

      return '';
    }
  }, {
    key: "getImageWidth",
    value: function getImageWidth() {
      var image = this.getImageObject();

      if (image && image.width) {
        return image.width;
      } else {
        return '';
      }
    }
  }, {
    key: "getImageHeight",
    value: function getImageHeight() {
      var image = this.getImageObject();

      if (image && image.height) {
        return image.height;
      } else {
        return '';
      }
    } // The stuff above was brought in from BaobabArticle  *****************************************************

  }, {
    key: "getHeadline",
    value: function getHeadline() {
      assert(this.headline);

      if (this.headline.length > 160) {
        return this.headline.replace(/([A-Za-z]*.\.)\s.*$/, '$1');
      } else {
        return this.headline;
      }
    } // getSectionLabel () {
    //   var sectionId = this.getSectionId()
    //   return Sections.getSectionLabel(sectionId)
    // }

  }, {
    key: "getSectionId",
    value: function getSectionId() {
      if (this.category) {
        return this.category;
      } else if (this.section) {
        return this.section;
      } else {
        logger.warn('getSectionId other', this.contentKey);
        return defaultArticleSectionUri;
      }
    } // getGrandSectionLabel () {
    //   var sectionId = this.getGrandSectionId(this)
    //   return Sections.getSectionLabel(sectionId)
    // }

  }, {
    key: "getGrandSectionId",
    value: function getGrandSectionId() {
      var sectionId = this.getSectionId();

      if (sectionId) {
        return sectionId.split('/')[0];
      }
    }
  }, {
    key: "getPath",
    value: function getPath() {
      return '/' + this.getUri();
    }
  }, {
    key: "getUri",
    value: function getUri() {
      var sectionId = this.getSectionId();

      if (!sectionId) {
        return this.getName();
      } else {
        return sectionId + '/' + this.getName();
      }
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.buildName() + '-' + this.contentKey;
    }
  }, {
    key: "buildName",
    value: function buildName() {
      return urlify(this.headline.replace(/\&/g, '-and-')).replace(/-+/g, '-');
    }
  }, {
    key: "getAbstract",
    value: function getAbstract() {
      if (this["abstract"]) {
        var _abstract = this["abstract"].trim();

        if (_abstract.length > 150) {
          var index = _abstract.indexOf('. ');

          if (index > 0 && index < 150) {
            _abstract = _abstract.substring(0, index + 1);
          } else {
            index = _abstract.substring(120).indexOf(' ');
            _abstract = _abstract.substring(0, 120 + index) + ' ...';
          }
        } else if (!_abstract.endsWith('.')) {}

        return _abstract;
      }
    }
  }, {
    key: "formatByline",
    value: function formatByline() {
      var author = this.getAuthor();

      if (author) {
        return 'By ' + author;
      } else {
        return '';
      }
    }
  }, {
    key: "getAuthor",
    value: function getAuthor() {
      if (!this) {
        // logger.warn('getAuthor')
        return null;
      } else if (this.author) {
        return this.author;
      } else if (this.byline) {
        if (this.byline.indexOf('By ') === 0) {
          return this.byline.substring(3);
        } else {
          return this.byline;
        }
      } else {
        // logger.debug('getAuthor empty', this.contentKey)
        return null;
      }
    }
  }, {
    key: "formatImageCredit",
    value: function formatImageCredit(index) {
      // logger.debug('formatImageCredit', this.contentKey, index)
      if (this.images && this.images.length > index && typeof this.images[index].credit === 'string') {
        return this.images[index].credit.replace(/\.$/, '');
      }

      return '';
    }
  }, {
    key: "formatImageCaption",
    value: function formatImageCaption() {
      try {
        var image = this.getImageObject();

        if (image) {
          if (image.captions && image.captions.length) {
            return image.captions.trim(); // TODO
          }

          if (Array.isArray(image.caption) && image.caption.length) {
            return image.caption.trim(); // TODO
          }

          return image.caption;
        }
      } catch (err) {
        logger.error(err);
      }

      return '';
    }
  }, {
    key: "formatImageCaptionCredit",
    value: function formatImageCaptionCredit(index) {
      var caption = this.formatImageCaption();
      var credit = this.formatImageCredit(0);

      if (!(0, _ionUtil.isEmpty)(caption)) {
        if (credit && caption.toLowerCase().indexOf(credit.toLowerCase()) < 0) {
          if (!caption.endsWith('.')) {
            caption += '. Credit: ' + credit;
          } else {
            caption += ' Credit: ' + credit;
          }
        }
      } else if (!(0, _ionUtil.isEmpty)(credit)) {
        caption = 'Credit: ' + credit;
      }

      return caption;
    }
  }, {
    key: "getYoutubeCardImage",
    value: function getYoutubeCardImage() {
      if (this.youtube) {
        return 'http://img.youtube.com/vi/' + this.youtube.id + '/0.jpg';
      }

      if (!(0, _ionUtil.isEmpty)(this.youtubes)) {
        return 'http://img.youtube.com/vi/' + this.youtubes[0].id + '/0.jpg';
      }
    }
  }, {
    key: "formatAgo",
    value: function formatAgo() {
      var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      try {
        if (this.published) {
          var published = new Date(this.published);
          var seconds = Math.floor((new Date() - published) / 1000);
          var interval = Math.floor(seconds / 43200);

          if (interval > 1) {
            return this.formatDate(true);
          }

          interval = Math.floor(seconds / 3600);

          if (interval >= 1) {
            return interval + 'h' + (full ? ' ago' : '');
          }

          interval = Math.floor(seconds / 60);

          if (interval > 1) {
            return interval + 'm' + (full ? ' ago' : '');
          }

          return Math.floor(seconds) + 's' + (full ? ' ago' : '');
        } else if (this.publishedString) {
          return this.publishedString;
        } else {// logger.warn('formatAgo published', this.contentKey, ObjectLogs.formatKeys(this.props))
        }
      } catch (err) {
        logger.error(err, 'formatAgo', this.contentKey, this.props);
      }

      return '';
    }
  }, {
    key: "parseDate",
    value: function parseDate() {
      if (this.published) {
        if (typeof this.published === 'string') {
          if (this.published.length === 16) {
            return Date.parse(this.published + 'Z');
          }
        } else if (Number.isInteger(this.published)) {
          return new Date(this.published);
        }
      } else {
        logger.error('parseDate', this.contentKey, this.published);
      }
    }
  }, {
    key: "formatDate",
    value: function formatDate(_short) {
      try {
        if (this.published) {
          return new Date(this.published).toLocaleDateString('en-US', {
            year: 'numeric',
            month: _short ? 'short' : 'long',
            day: 'numeric'
          });
        } else if (this.publishedString) {
          return this.publishedString;
        } else {
          logger.warn('formatDate', this.contentKey);
        }
      } catch (err) {
        logger.error(err, 'formatDate', this.contentKey);
      }

      return '';
    }
  }, {
    key: "getCompetitionSlug",
    value: function getCompetitionSlug() {
      var match = this.bodyHTML.match(COMPETITION_REGEX.replace('%s', SLUG_REGEX));

      if (match && match.length > 1) {
        return match[1];
      }

      return false;
    }
  }, {
    key: "hasCompetitionSlug",
    value: function hasCompetitionSlug() {
      return this.getCompetitionSlug() !== false;
    }
  }, {
    key: "setCompetition",
    value: function setCompetition(competitionSlug, competitionHTML) {
      return this.bodyHTML.replace(new RegExp(COMPETITION_REGEX.replace('%s', competitionSlug)), competitionHTML);
    }
  }, {
    key: "getTimelineSlugs",
    value: function getTimelineSlugs() {
      var timelineMatches = this.bodyHTML.match(TIMELINE_REGEX);
      var timelineSlugs = timelineMatches === null || timelineMatches === void 0 ? void 0 : timelineMatches.map(function (match) {
        return match.match(/\[timeline=([^ ]+)(?: mode=([^ ]+))?\]/)[1];
      });

      if (timelineSlugs && timelineSlugs.length > 0) {
        return timelineSlugs;
      }

      return false;
    }
  }]);

  return Article;
}();

exports["default"] = Article;

function parseArticle(_x) {
  return _parseArticle.apply(this, arguments);
}

function _parseArticle() {
  _parseArticle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rawArticle) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _parseArticle2.parseArticleData)(rawArticle));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _parseArticle.apply(this, arguments);
}